import { EncounterForMonth } from "./EncounterForMonth";
import { EncountersPerMonth } from "./EncountersPerMonth";

export enum IndividualCareProviderType {
  ENCOUNTER2_5,
  ENCOUNTER20,
  FORFAIT,
}

export interface IndividualCareProvider {
  profession?: string;
  nihdi?: string;
  nihdiQualification?: string;
  encounters?: EncountersPerMonth[];
  forfait?: EncounterForMonth[];
}

export interface IndividualCareProviderByType {
  type: IndividualCareProviderType;
  profession?: string;
  nihdi?: string;
  nihdiQualification?: string;
  encounters?: {
    [periodCode: string]: {[run: number]: EncountersPerMonth[]};
  };
  forfaits?: {
    [periodCode: string]: {[run: number]: EncounterForMonth[]};
  };
}